import { UseCase } from '@core/referential/use-case.enum'
import { createFileRoute } from '@tanstack/react-router'

import { companySettingsQuery } from '@/queries/company.settings.query'

export const Route = createFileRoute('/_dashboard')({
  // Les réglages company portent les sections de sidebar masquées : les précharger permet à la
  // requête de partir avant le rendu de la sidebar. Restreint au GTB, seul module à les consommer
  // pour sa navigation — inutile de le demander aux autres. Volontairement non attendu (`void`) :
  // la navigation n'est pas bloquée, le squelette de sidebar couvre l'attente.
  //
  // `prefetchQuery` et non `ensureQueryData` : cette dernière REJETTE en cas d'échec, et un `void`
  // ne capture rien. Avec `retry: 0`, une seule réponse en erreur produirait un rejet non capturé
  // (donc remonté à Sentry) à chaque navigation sous /_dashboard. La sidebar sait se rabattre sur
  // l'affichage complet : l'échec du préchargement n'a rien à signaler.
  beforeLoad({ context }) {
    if (context.user?.currentUseCase === UseCase.ENERGY) {
      void context.queryClient.prefetchQuery(companySettingsQuery())
    }
  },
})
